module.exports = __webpack_public_path__ + "static/email-design-dots-2-f2e54f75609607350cfbcd65aa1dc753.svg";